import { weekDays } from "../utils";

const BookingEmailTemplate = ({ booking, adminEmail }) => {
  const getRecurrenceDetails = () => {
    if (!booking.isRecurring) return "";
    let recurrenceInfo = `<strong>Recurrence:</strong> ${
      booking.recurrenceType.charAt(0).toUpperCase() +
      booking.recurrenceType.slice(1)
    }`;
    if (
      booking.recurrenceType === "weekly" &&
      booking.recurrenceDays.length > 0
    ) {
      const dayNames = booking.recurrenceDays
        .map((id) => weekDays.find((day) => day.id === id)?.name)
        .filter(Boolean)
        .join(", ");
      recurrenceInfo += ` on ${dayNames}`;
    }
    recurrenceInfo += ` until ${booking.recurrenceEndDate}`;
    return recurrenceInfo;
  };

  return `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          body {
            font-family: 'Arial', sans-serif;
            background-color: #f4f4f4;
            margin: 0;
            padding: 0;
          }
          .container {
            max-width: 600px;
            margin: 20px auto;
            background-color: #f2f2f2;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            overflow: hidden;
          }
          .header {
            background-color: #00edc3;
            color: #555555;
            padding: 20px;
            text-align: center;
          }
          .header h1 {
            margin: 0;
            font-size: 24px;
          }
          .content {
            padding: 30px;
          }
          .content h2 {
            color: #333333;
            font-size: 20px;
            margin-bottom: 20px;
          }
          .content p {
            color: #555555;
            font-size: 16px;
            line-height: 1.6;
            margin: 10px 0;
          }
          .content .detail {
            margin-bottom: 15px;
          }
          .content .detail strong {
            color: #333333;
            display: inline-block;
            width: 120px;
          }
          .footer {
            background-color: #f8f8f8;
            padding: 20px;
            text-align: center;
            font-size: 14px;
            color: #777777;
          }
          .footer a {
            color: #00edc3;
            text-decoration: none;
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h1>${
              booking.cancelled
                ? "Room Booking Cancellation"
                : booking.updated
                ? "Room Booking Update"
                : "Room Booking Confirmation"
            }</h1>
          </div>
          <div class="content">
            <h2>Booking Details</h2>
            <div class="detail"><strong>Room:</strong> ${
              booking.room.name
            }</div>
            <div class="detail"><strong>Date:</strong> ${booking.date}</div>
            <div class="detail"><strong>Time:</strong> ${booking.startTime} - ${
    booking.endTime
  }</div>
            <div class="detail"><strong>Purpose:</strong> ${
              booking.purpose
            }</div>
            <div class="detail"><strong>Booked by:</strong> ${booking.name} 
            ${adminEmail ? "" : `(${booking.email})`}</div>
            ${
              booking.isRecurring
                ? `<div class="detail">${getRecurrenceDetails()}</div>`
                : ""
            }
            ${
              adminEmail
                ? `<div class="detail"><strong>Handled by Admin:</strong> ${adminEmail}</div>`
                : ""
            }
          </div>
          <div class="footer">
            <p>This is an automated email from the KOLVN Room Booking System. For any inquiries, please contact <a href="mailto:webmaster@kambria.io">webmaster@kambria.io</a>.</p>
          </div>
        </div>
      </body>
      </html>
    `;
};
export default BookingEmailTemplate;
